import { Device } from 'DeviceUtils';
import Theme from 'Theme';
import { TextStyle, ViewStyle } from 'react-native';

let wrapper: ViewStyle = {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    zIndex: 9999
};
let header: { iconContainer: ViewStyle } = {
    iconContainer: {
        position: 'absolute',
        top: 0,
        right: 0,
        marginTop: 10
    }
};
let main: ViewStyle = {
    flex: 0.35,
    backgroundColor: 'rgba(0,0,0,0.9)'
};
let container: ViewStyle = {
    paddingVertical: 30,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center'
};
let content: ViewStyle = {
    flex: 0.8
};
let scrollContent: ViewStyle = {
    paddingRight: 15,
    gap: 20
};
let title: TextStyle = {
    fontSize: 28,
    fontWeight: 300,
    color: '#fff',
    fontFamily: Theme.regularFont
};
const divider: ViewStyle = {
    height: 0.5,
    backgroundColor: '#fff'
};
const description: TextStyle = {
    paddingBottom: 20,
    fontSize: 18,
    color: '#fff',
    fontFamily: Theme.regularFont
};
let buttonsContainer: ViewStyle = {
    gap: 20
};
let button: { text?: TextStyle; button?: ViewStyle } = {
    text: {
        fontSize: 25,
        fontFamily: Theme.mediumFont
    }
};
if (Device.isPhone) {
    wrapper = { flex: 1, backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 9999 };
    header = {
        iconContainer: {
            position: 'absolute',
            right: 0
        }
    };
    main = {
        flex: 1,
        paddingVertical: 30,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    };
    content = {
        flex: 0.7
    };
    scrollContent = {
        flexGrow: 1,
        paddingRight: 15,
        justifyContent: 'center',
        gap: 20
    };
    title = {
        fontSize: 28,
        fontWeight: 300,
        color: '#fff',
        fontFamily: Theme.regularFont
    };
    buttonsContainer = {
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 50
    };
    button = { button: { flex: 1 } };
}

if (Device.isIos) header.iconContainer.zIndex = 9999;

if (Device.isWeb) {
    main = {
        ...main,
        flex: 0.5
    };
}

export default {
    wrapper,
    header,
    main,
    container,
    content,
    scrollContent,
    title,
    divider,
    description,
    buttonsContainer,
    button
};
